import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "price-notification ion-text-center"
}
const _hoisted_2 = { class: "ma-0 color-black bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.showNotification)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, [
          _createTextVNode(" Changing location may mean different prices, menu items, or " + _toDisplayString(_ctx.isDelivery ? 'delivery may take more time' : 'longer wait times') + ". ", 1),
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.back())),
            class: "no-underline color-primary"
          }, "Go Back")
        ])
      ]))
    : _createCommentVNode("", true)
}